import { render, staticRenderFns } from "./arAccount.vue?vue&type=template&id=18f3774d&scoped=true"
import script from "./arAccount.vue?vue&type=script&lang=js"
export * from "./arAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3774d",
  null
  
)

export default component.exports